import { AxiosError } from "axios";
import { enqueueSnackbar } from "notistack";
import React from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { useAuth } from "src/shared/context/useAuth";
import { getUnregisteredCases } from "./gateway";
import { MRT_PaginationState } from "material-react-table";

export default function useGetUnregisteredCases({
  filters,
  enabled,
  setEnableSearch,
  paginationState,
}: {
  enabled: Boolean;
  filters: Object;
  setEnableSearch: React.Dispatch<React.SetStateAction<Boolean>>;
  paginationState: MRT_PaginationState;
}) {
  const navigate = useNavigate();
  const { userHomePath } = useAuth();

  return useQuery({
    queryFn: () => getUnregisteredCases(filters, paginationState),
    queryKey: ["unregistered-cased", filters, paginationState],
    onError: (error: AxiosError<string>) => {
      navigate(userHomePath);
      enqueueSnackbar(error.response?.data, { variant: "error" });
    },
    onSettled: () => {
      setEnableSearch(false);
    },
    enabled: !!enabled,
  });
}
